import { jsxs as e, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as i } from "./index.es2447.js";
function d({ size: l = i }) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M41 25.8333C41 24.6367 40.0299 23.6666 38.8333 23.6666C37.6367 23.6666 36.6667 24.6367 36.6667 25.8333V38.8333C36.6667 40.0299 37.6367 41 38.8333 41C40.0299 41 41 40.0299 41 38.8333V25.8333Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M29.4444 33.0555C29.4444 31.8589 30.4145 30.8888 31.6111 30.8888C32.8077 30.8888 33.7778 31.8589 33.7778 33.0555V38.8333C33.7778 40.0299 32.8077 41 31.6111 41C30.4145 41 29.4444 40.0299 29.4444 38.8333V33.0555Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M23.6667 37.3888C23.6667 36.1922 24.6367 35.2222 25.8333 35.2222C27.0299 35.2222 28 36.1922 28 37.3888V38.8333C28 40.0299 27.0299 41 25.8333 41C24.6367 41 23.6667 40.0299 23.6667 38.8333V37.3888Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M23.6667 32.3333C28.445 32.3333 32.3333 28.445 32.3333 23.6667C32.3333 18.8883 28.445 15 23.6667 15C18.8883 15 15 18.8883 15 23.6667C15 28.445 18.8883 32.3333 23.6667 32.3333Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M23.3577 19.774H24.0559V20.877C24.291 20.9207 24.5262 20.9943 24.7612 21.0977C25.0161 21.2097 25.2401 21.341 25.4328 21.4918L25.4908 21.5372L25.0229 22.1115L24.9669 22.0659L24.9235 22.1237C24.7238 21.9736 24.5011 21.8563 24.2552 21.7717C24.0079 21.6868 23.7852 21.6453 23.5864 21.6453C23.3026 21.6453 23.083 21.7088 22.9211 21.8287C22.7635 21.9454 22.6835 22.1095 22.6835 22.3307C22.6835 22.4209 22.702 22.5013 22.738 22.5733C22.7763 22.6496 22.8224 22.7134 22.8762 22.7655C22.9292 22.8169 23.0098 22.8715 23.1215 22.9281C23.235 22.9857 23.3386 23.0329 23.4324 23.0699C23.5269 23.1072 23.6552 23.1529 23.8178 23.207C23.9997 23.2668 24.1405 23.3137 24.2399 23.3478C24.3409 23.3824 24.4655 23.4306 24.6134 23.492C24.7624 23.5538 24.8808 23.6129 24.9666 23.6694C25.0504 23.7248 25.1408 23.7956 25.2375 23.8814C25.3377 23.9701 25.4154 24.0651 25.4684 24.1667C25.5195 24.2648 25.5621 24.3793 25.5965 24.5095C25.6318 24.6426 25.6491 24.7867 25.6491 24.9414C25.6491 25.388 25.5014 25.759 25.2038 26.0481C24.9196 26.3242 24.5348 26.4846 24.0559 26.5346V27.5592H23.3577V26.5247C22.7379 26.4437 22.1868 26.1655 21.7059 25.6935L21.6587 25.6472L22.1261 25.0788L22.1819 25.1246L22.233 25.0737C22.4515 25.2928 22.6959 25.4591 22.9664 25.5734C23.2381 25.6882 23.5048 25.7449 23.767 25.7449C24.0687 25.7449 24.3062 25.6737 24.4859 25.5376C24.6621 25.4041 24.7502 25.223 24.7502 24.9862C24.7502 24.8778 24.7316 24.7825 24.6959 24.699C24.6586 24.6121 24.6122 24.5401 24.5572 24.4819C24.503 24.4244 24.4227 24.3664 24.3133 24.3089C24.202 24.2504 24.0937 24.2014 23.9884 24.1619C23.882 24.1219 23.7411 24.0748 23.5652 24.0207C23.4043 23.969 23.2754 23.9257 23.1806 23.8913C23.0853 23.8568 22.9683 23.8101 22.8299 23.7514C22.6902 23.6922 22.577 23.6354 22.4919 23.5807C22.4084 23.527 22.3183 23.4592 22.2216 23.3776C22.1216 23.2933 22.0427 23.2029 21.9869 23.106C21.9327 23.0119 21.8878 22.9033 21.8517 22.7808C21.8148 22.6553 21.7966 22.52 21.7966 22.3755C21.7966 21.9423 21.9411 21.5792 22.2314 21.2917C22.5093 21.0165 22.8872 20.8643 23.3577 20.8291V19.774Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.6667 32.3333C28.445 32.3333 32.3333 28.445 32.3333 23.6667C32.3333 18.8883 28.445 15 23.6667 15C18.8883 15 15 18.8883 15 23.6667C15 28.445 18.8883 32.3333 23.6667 32.3333ZM23.6667 31.25C27.8467 31.25 31.25 27.8467 31.25 23.6667C31.25 19.4866 27.8467 16.0833 23.6667 16.0833C19.4866 16.0833 16.0833 19.4866 16.0833 23.6667C16.0833 27.8467 19.4866 31.25 23.6667 31.25Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M35.9444 24.3889C35.9444 23.99 36.2678 23.6667 36.6667 23.6667H40.2778C40.6766 23.6667 41 23.99 41 24.3889V40.2778C41 40.6766 40.6766 41 40.2778 41H36.6667C36.2678 41 35.9444 40.6766 35.9444 40.2778V24.3889ZM37.0278 24.75H39.9167V39.9167H37.0278V24.75Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29.4444 31.6112C29.4444 31.2123 29.7678 30.889 30.1667 30.8889L33.7778 30.8889C34.1766 30.8889 34.5 31.2122 34.5 31.6111V40.2778C34.5 40.6766 34.1766 41 33.7778 41H30.1667C29.7678 41 29.4444 40.6766 29.4444 40.2778V31.6112ZM30.5278 39.9167V31.9723L33.4167 31.9722V39.9167H30.5278Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.6667 35.2222C23.2678 35.2222 22.9444 35.5456 22.9444 35.9444V40.2778C22.9444 40.6766 23.2678 41 23.6667 41H27.2778C27.6766 41 28 40.6766 28 40.2778V35.9444C28 35.5456 27.6766 35.2222 27.2778 35.2222H23.6667ZM24.0278 36.3056V39.9167H26.9167V36.3056H24.0278Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
d.__tags = [];
export {
  d as MetricSalesIcon
};
//# sourceMappingURL=index.es421.js.map
